import type { TvSeries } from '@/types';

export const tvSeriesList: TvSeries[] = [
  {
    id: 'changye',
    title: '长夜星河',
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20Chinese%20period%20drama%20poster%20art%2C%20lone%20figure%20in%20dark%20blue%20silk%20robe%20standing%20on%20ancient%20palace%20rooftop%20under%20a%20vast%20starry%20night%20sky%2C%20moody%20indigo%20and%20gold%20tones%2C%20dramatic%20lighting%2C%20no%20text%2C%20painterly%20illustration&width=600&height=900&seq=tv-poster-01&orientation=portrait',
    tags: ['古装', '权谋', '历史'],
    region: '中国大陆',
    year: 2025,
    episodes: 48,
    director: '沈牧',
    cast: ['陆祈年', '苏晚棠', '顾承砚'],
    synopsis:
      '乱世将倾，寒门书生陆祈年以一手星象推演之策入仕朝堂，在波谲云诡的权谋漩涡中步步为营。他与落魄郡主苏晚棠从彼此试探到并肩而立，试图在长夜之中点亮一片属于自己的星河。全剧以恢弘的朝堂群像与细腻的人心博弈，讲述一个关于信念、隐忍与守护的故事。',
    rating: 9.1,
    popularity: 9860,
    createdAt: '2025-09-12',
    roles: [
      { actor: '陆祈年', role: '饰 陆祈年（寒门谋士）', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20young%20Chinese%20male%20scholar%20in%20dark%20blue%20traditional%20robe%2C%20calm%20and%20thoughtful%20expression%2C%20soft%20studio%20lighting%2C%20muted%20indigo%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-01a&orientation=squarish' },
      { actor: '苏晚棠', role: '饰 苏晚棠（落魄郡主）', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20an%20elegant%20young%20Chinese%20woman%20in%20pale%20gold%20traditional%20dress%20with%20ornate%20hairpin%2C%20gentle%20determined%20gaze%2C%20soft%20studio%20lighting%2C%20warm%20neutral%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-01b&orientation=squarish' },
      { actor: '顾承砚', role: '饰 顾承砚（铁血将军）', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20stern%20Chinese%20general%20in%20dark%20armor%20with%20short%20beard%2C%20intense%20expression%2C%20dramatic%20studio%20lighting%2C%20dark%20grey%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-01c&orientation=squarish' },
    ],
  },
  {
    id: 'chunri',
    title: '春日便利店',
    poster: 'https://readdy.ai/api/search-image?query=warm%20healing%20romance%20drama%20poster%2C%20cozy%20convenience%20store%20at%20sunset%20with%20warm%20orange%20glow%2C%20two%20silhouettes%20chatting%20behind%20the%20counter%2C%20cherry%20blossom%20petals%20floating%2C%20soft%20pastel%20tones%2C%20no%20text%2C%20painterly%20illustration&width=600&height=900&seq=tv-poster-02&orientation=portrait',
    tags: ['现代', '爱情', '治愈'],
    region: '中国大陆',
    year: 2025,
    episodes: 32,
    director: '林知夏',
    cast: ['温以宁', '程屿', '周小满'],
    synopsis:
      '深夜十一点的便利店，是这座城市最后亮着的一盏灯。夜班店员温以宁习惯用一杯热牛奶迎接每一位疲惫的客人，直到那个总在凌晨来买同一款饭团的男人程屿出现。两个各自带着伤口的人在小小的货架之间慢慢靠近，用最平凡的日常治愈彼此。',
    rating: 8.6,
    popularity: 9120,
    createdAt: '2025-08-28',
    roles: [
      { actor: '温以宁', role: '饰 温以宁（夜班店员）', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20gentle%20young%20Chinese%20woman%20with%20soft%20smile%20and%20shoulder%20length%20hair%2C%20warm%20orange%20soft%20lighting%2C%20cream%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-02a&orientation=squarish' },
      { actor: '程屿', role: '饰 程屿（建筑师）', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20quiet%20young%20Chinese%20man%20in%20beige%20knit%20sweater%20with%20slight%20smile%2C%20warm%20soft%20lighting%2C%20muted%20beige%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-02b&orientation=squarish' },
    ],
  },
  {
    id: 'wucheng',
    title: '雾城谜案',
    poster: 'https://readdy.ai/api/search-image?query=dark%20mystery%20crime%20drama%20poster%2C%20rainy%20foggy%20city%20street%20at%20night%20with%20a%20lone%20detective%20silhouette%20holding%20an%20umbrella%2C%20cold%20teal%20and%20charcoal%20tones%2C%20neon%20reflections%2C%20suspenseful%20atmosphere%2C%20no%20text%2C%20cinematic%20illustration&width=600&height=900&seq=tv-poster-03&orientation=portrait',
    tags: ['悬疑', '犯罪', '刑侦'],
    region: '中国大陆',
    year: 2025,
    episodes: 24,
    director: '郑砚舟',
    cast: ['江澈', '许清和', '阮明月'],
    synopsis:
      '一场持续十年的大雾笼罩着这座城市，也掩盖了七宗悬而未决的旧案。刑警江澈在调查一桩新案时，发现线索竟全部指向自己尘封的过去。随着真相一层层被揭开，他不得不面对一个残酷的疑问：最亲近的人，是否就是那个藏在雾里的人。',
    rating: 9.3,
    popularity: 10340,
    createdAt: '2025-10-02',
    roles: [
      { actor: '江澈', role: '饰 江澈（刑警队长）', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20serious%20Chinese%20male%20detective%20with%20short%20hair%20and%20stubble%2C%20cold%20cyan%20lighting%2C%20dark%20charcoal%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-03a&orientation=squarish' },
      { actor: '许清和', role: '饰 许清和（法医）', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20composed%20Chinese%20woman%20in%20a%20white%20coat%20with%20glasses%2C%20cool%20studio%20lighting%2C%20pale%20blue%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-03b&orientation=squarish' },
    ],
  },
  {
    id: 'haibian',
    title: '海边的旧信',
    poster: 'https://readdy.ai/api/search-image?query=literary%20romance%20drama%20poster%2C%20windswept%20seaside%20cliff%20with%20a%20wooden%20mailbox%20and%20old%20letters%2C%20a%20young%20woman%20reading%20by%20the%20waves%2C%20muted%20ocean%20blue%20and%20cream%20tones%2C%20nostalgic%20film%20grain%2C%20no%20text%2C%20painterly%20illustration&width=600&height=900&seq=tv-poster-04&orientation=portrait',
    tags: ['爱情', '文艺', '剧情'],
    region: '中国大陆',
    year: 2024,
    episodes: 20,
    director: '苏也',
    cast: ['林昭昭', '闻时野'],
    synopsis:
      '整理祖母遗物时，林昭昭发现了一叠从未寄出的旧信，收信人是一个她从未听过的名字。循着信里的地址，她来到一座海边小镇，遇见了守着老邮局的闻时野。两段跨越半世纪的人生，在一封封旧信里慢慢交汇。',
    rating: 8.8,
    popularity: 7640,
    createdAt: '2024-11-19',
    roles: [
      { actor: '林昭昭', role: '饰 林昭昭', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20soft%20young%20Chinese%20woman%20with%20natural%20makeup%20and%20loose%20hair%2C%20gentle%20natural%20light%2C%20pale%20cream%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-04a&orientation=squarish' },
      { actor: '闻时野', role: '饰 闻时野', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20calm%20young%20Chinese%20man%20in%20a%20linen%20shirt%20by%20the%20sea%2C%20soft%20muted%20blue%20lighting%2C%20cream%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-04b&orientation=squarish' },
    ],
  },
  {
    id: 'niguang',
    title: '逆光而行',
    poster: 'https://readdy.ai/api/search-image?query=inspiring%20urban%20drama%20poster%2C%20young%20professional%20walking%20through%20a%20modern%20glass%20city%20corridor%20backlit%20by%20warm%20sunlight%2C%20bold%20orange%20and%20deep%20indigo%20contrast%2C%20dynamic%20composition%2C%20no%20text%2C%20cinematic%20illustration&width=600&height=900&seq=tv-poster-05&orientation=portrait',
    tags: ['都市', '励志', '职场'],
    region: '中国大陆',
    year: 2025,
    episodes: 36,
    director: '方遇',
    cast: ['孟星禾', '裴亦寒', '黎川'],
    synopsis:
      '从实习生到项目掌舵人，孟星禾用了整整八年。她在男性主导的行业里一次次被否定、又一次次站起来，用扎实的专业能力回击所有质疑。这是一部关于成长、尊严与不妥协的都市励志故事，献给每一个逆光而行的人。',
    rating: 8.4,
    popularity: 8210,
    createdAt: '2025-07-15',
    roles: [
      { actor: '孟星禾', role: '饰 孟星禾（项目经理）', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20confident%20Chinese%20businesswoman%20in%20a%20tailored%20blazer%20with%20short%20bob%20hair%2C%20bright%20studio%20lighting%2C%20warm%20neutral%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-05a&orientation=squarish' },
      { actor: '裴亦寒', role: '饰 裴亦寒', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20charismatic%20Chinese%20man%20in%20a%20slim%20dark%20suit%2C%20clean%20studio%20lighting%2C%20grey%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-05b&orientation=squarish' },
    ],
  },
  {
    id: 'yunshang',
    title: '云上归途',
    poster: 'https://readdy.ai/api/search-image?query=heartwarming%20family%20drama%20poster%2C%20quiet%20mountain%20village%20with%20terraced%20fields%20at%20dusk%2C%20an%20old%20house%20with%20warm%20lights%2C%20soft%20green%20and%20amber%20tones%2C%20gentle%20nostalgic%20mood%2C%20no%20text%2C%20painterly%20illustration&width=600&height=900&seq=tv-poster-06&orientation=portrait',
    tags: ['家庭', '温情', '年代'],
    region: '中国大陆',
    year: 2024,
    episodes: 30,
    director: '陆迁',
    cast: ['何知遥', '老周', '周念'],
    synopsis:
      '在大城市打拼多年的何知遥因一场变故回到阔别已久的山村老家，重新面对那个固执的父亲和早已陌生的故乡。在一日日的相处中，两代人的心结被慢慢解开，她终于明白，归途从来不是退路，而是另一种出发。',
    rating: 9.0,
    popularity: 7050,
    createdAt: '2024-09-30',
    roles: [
      { actor: '何知遥', role: '饰 何知遥', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20warm%20young%20Chinese%20woman%20in%20a%20simple%20knit%20sweater%2C%20natural%20outdoor%20light%2C%20soft%20green%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-06a&orientation=squarish' },
      { actor: '老周', role: '饰 何父', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20an%20elderly%20Chinese%20farmer%20with%20weathered%20face%20and%20grey%20hair%2C%20warm%20natural%20lighting%2C%20earthy%20brown%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-06b&orientation=squarish' },
    ],
  },
  {
    id: 'shouer',
    title: '首尔凌晨三点',
    poster: 'https://readdy.ai/api/search-image?query=Korean%20romance%20drama%20poster%2C%20rainy%20Seoul%20street%20at%203am%20with%20glowing%20signs%2C%20two%20figures%20sharing%20an%20umbrella%20under%20a%20warm%20streetlamp%2C%20moody%20purple%20blue%20and%20amber%20tones%2C%20cinematic%20bokeh%2C%20no%20text%2C%20painterly%20illustration&width=600&height=900&seq=tv-poster-07&orientation=portrait',
    tags: ['韩国', '爱情', '都市'],
    region: '韩国',
    year: 2025,
    episodes: 16,
    director: 'Kim Hyun-woo',
    cast: ['이서연', '박도현'],
    synopsis:
      '凌晨三点的首尔，便利店、广播电台和深夜巴士构成了这座城市不眠的风景。电台深夜节目主持人李瑞妍与失眠的钢琴调律师朴道贤，通过一通打错的电话相识。两个孤独的灵魂，在无数个不眠的凌晨里互相点亮。',
    rating: 8.9,
    popularity: 8890,
    createdAt: '2025-06-21',
    roles: [
      { actor: '이서연', role: '饰 李瑞妍（电台主持）', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20an%20elegant%20Korean%20woman%20radio%20host%20with%20long%20wavy%20hair%2C%20soft%20moody%20purple%20lighting%2C%20dark%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-07a&orientation=squarish' },
      { actor: '박도현', role: '饰 朴道贤（调律师）', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20gentle%20Korean%20man%20in%20a%20dark%20coat%20with%20calm%20eyes%2C%20warm%20amber%20lighting%2C%20deep%20blue%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-07b&orientation=squarish' },
    ],
  },
  {
    id: 'chenmo',
    title: '沉默的证词',
    poster: 'https://readdy.ai/api/search-image?query=American%20crime%20thriller%20series%20poster%2C%20empty%20courtroom%20with%20a%20single%20spotlight%20on%20an%20empty%20witness%20stand%2C%20cold%20desaturated%20grey%20and%20deep%20red%20tones%2C%20tense%20atmosphere%2C%20no%20text%2C%20cinematic%20illustration&width=600&height=900&seq=tv-poster-08&orientation=portrait',
    tags: ['美剧', '悬疑', '律政'],
    region: '美国',
    year: 2025,
    episodes: 12,
    director: 'Daniel Ross',
    cast: ['Emma Shaw', 'Michael Reyes'],
    synopsis:
      '一名被告在法庭上全程保持沉默，所有人都认定这是认罪的信号。年轻的公设辩护人艾玛却发现，这份沉默背后藏着一个足以颠覆整个案件的秘密。当真相与程序正义发生冲突，她必须在职业信仰与内心正义之间做出选择。',
    rating: 9.2,
    popularity: 8640,
    createdAt: '2025-05-08',
    roles: [
      { actor: 'Emma Shaw', role: '饰 艾玛·肖（辩护律师）', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20determined%20young%20American%20female%20lawyer%20in%20a%20grey%20blazer%2C%20cool%20studio%20lighting%2C%20neutral%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-08a&orientation=squarish' },
      { actor: 'Michael Reyes', role: '饰 迈克尔·雷耶斯（检控官）', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20serious%20middle%20aged%20American%20man%20prosecutor%20with%20glasses%2C%20cold%20lighting%2C%20grey%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-08b&orientation=squarish' },
    ],
  },
  {
    id: 'changan',
    title: '长安十二时',
    poster: 'https://readdy.ai/api/search-image?query=epic%20historical%20Chinese%20drama%20poster%2C%20magnificent%20ancient%20Tang%20dynasty%20city%20at%20dusk%20with%20red%20lanterns%20and%20palace%20towers%2C%20a%20single%20figure%20on%20horseback%2C%20rich%20crimson%20and%20gold%20tones%2C%20grand%20cinematic%20scale%2C%20no%20text%2C%20painterly%20illustration&width=600&height=900&seq=tv-poster-09&orientation=portrait',
    tags: ['古装', '历史', '群像'],
    region: '中国大陆',
    year: 2024,
    episodes: 42,
    director: '裴远山',
    cast: ['萧无咎', '长孙昭', '柳明月'],
    synopsis:
      '长安城一日，人间十二年。上元灯节当夜，一场看似普通的走水引发连锁谜团，牵出朝堂内外数股势力的角逐。剧集以十二个时辰为轴，将一位位小人物的命运编织进浩荡的时代洪流之中，绘就一幅鲜活的长安众生相。',
    rating: 9.4,
    popularity: 11200,
    createdAt: '2024-12-25',
    roles: [
      { actor: '萧无咎', role: '饰 萧无咎', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20handsome%20young%20Chinese%20man%20in%20ornate%20Tang%20dynasty%20costume%2C%20warm%20golden%20lighting%2C%20deep%20red%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-09a&orientation=squarish' },
      { actor: '长孙昭', role: '饰 长孙昭', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20noble%20young%20Chinese%20woman%20in%20elaborate%20Tang%20dynasty%20headwear%20and%20red%20silk%2C%20warm%20golden%20lighting%2C%20crimson%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-09b&orientation=squarish' },
    ],
  },
  {
    id: 'liangzi',
    title: '量子边界',
    poster: 'https://readdy.ai/api/search-image?query=sci-fi%20thriller%20series%20poster%2C%20glowing%20abstract%20quantum%20particle%20grid%20with%20a%20human%20silhouette%20facing%20a%20vast%20digital%20horizon%2C%20electric%20cobalt%20blue%20and%20deep%20space%20black%20tones%2C%20futuristic%20cinematic%20mood%2C%20no%20text%2C%20digital%20illustration&width=600&height=900&seq=tv-poster-10&orientation=portrait',
    tags: ['美剧', '科幻', '惊悚'],
    region: '美国',
    year: 2025,
    episodes: 10,
    director: 'Sarah Nkemi',
    cast: ['Nora Bennett', 'Ethan Cole'],
    synopsis:
      '物理学家诺拉在一次量子实验中发现，每次观测都会分裂出一个平行世界，而其中一个世界正在崩溃，并试图吞噬其他所有世界。为了拯救自己的现实，她必须穿越层层边界，面对无数个版本的自己。',
    rating: 8.7,
    popularity: 7980,
    createdAt: '2025-04-11',
    roles: [
      { actor: 'Nora Bennett', role: '饰 诺拉·班尼特（物理学家）', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20brilliant%20American%20female%20scientist%20with%20short%20hair%20and%20focused%20gaze%2C%20cool%20blue%20lighting%2C%20dark%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-10a&orientation=squarish' },
      { actor: 'Ethan Cole', role: '饰 伊森·科尔', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20thoughtful%20American%20man%20in%20a%20dark%20turtleneck%2C%20moody%20blue%20lighting%2C%20dark%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-10b&orientation=squarish' },
    ],
  },
  {
    id: 'jifeng',
    title: '季风起时',
    poster: 'https://readdy.ai/api/search-image?query=youth%20coming%20of%20age%20drama%20poster%2C%20group%20of%20friends%20cycling%20along%20a%20coastal%20road%20during%20monsoon%20season%2C%20dramatic%20grey%20clouds%20and%20bright%20green%20fields%2C%20fresh%20energetic%20mood%2C%20no%20text%2C%20painterly%20illustration&width=600&height=900&seq=tv-poster-11&orientation=portrait',
    tags: ['现代', '青春', '成长'],
    region: '中国大陆',
    year: 2024,
    episodes: 28,
    director: '林知夏',
    cast: ['夏一苇', '陈叙'],
    synopsis:
      '高三那年，季风如期而至，也带来了人生中最重要的一场告别。夏一苇和她的朋友们在潮湿的海风里长大，在试卷与梦想之间挣扎，在第一次心动与第一次失去中学会告别。这是关于每一个人青春里那场下不完的雨。',
    rating: 8.5,
    popularity: 6890,
    createdAt: '2024-07-08',
    roles: [
      { actor: '夏一苇', role: '饰 夏一苇', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20fresh%20young%20Chinese%20student%20girl%20with%20ponytail%20and%20bright%20smile%2C%20natural%20daylight%2C%20soft%20green%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-11a&orientation=squarish' },
      { actor: '陈叙', role: '饰 陈叙', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20cheerful%20young%20Chinese%20teenage%20boy%20in%20school%20uniform%2C%20natural%20daylight%2C%20soft%20grey%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-11b&orientation=squarish' },
    ],
  },
  {
    id: 'anfang',
    title: '暗房',
    poster: 'https://readdy.ai/api/search-image?query=psychological%20thriller%20poster%2C%20dark%20photography%20darkroom%20with%20red%20safelight%20and%20developing%20photos%20hanging%2C%20a%20lone%20figure%20in%20shadow%2C%20deep%20crimson%20and%20black%20tones%2C%20eerie%20suspense%2C%20no%20text%2C%20cinematic%20illustration&width=600&height=900&seq=tv-poster-12&orientation=portrait',
    tags: ['悬疑', '惊悚', '心理'],
    region: '中国大陆',
    year: 2025,
    episodes: 18,
    director: '郑砚舟',
    cast: ['路遥', '顾晚'],
    synopsis:
      '自由摄影师路遥习惯了用镜头记录别人的生活，直到她在冲洗一批旧胶片时，发现里面出现了一个本不该存在的人影。随着暗房里的照片越来越多，她逐渐分不清哪些是真实的记忆，哪些是自己被篡改的幻觉。',
    rating: 8.6,
    popularity: 6520,
    createdAt: '2025-03-17',
    roles: [
      { actor: '路遥', role: '饰 路遥（摄影师）', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20an%20artistic%20Chinese%20woman%20photographer%20with%20dark%20hair%20and%20camera%2C%20dim%20red%20lighting%2C%20dark%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-12a&orientation=squarish' },
      { actor: '顾晚', role: '饰 顾晚', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20mysterious%20pale%20Chinese%20woman%20with%20long%20straight%20hair%2C%20dim%20lighting%2C%20dark%20grey%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-12b&orientation=squarish' },
    ],
  },
  {
    id: 'xueluo',
    title: '雪落无声',
    poster: 'https://readdy.ai/api/search-image?query=period%20drama%20poster%2C%20quiet%20snowy%20northern%20town%20in%20the%201990s%20with%20a%20steam%20train%20and%20warm%20window%20lights%2C%20a%20figure%20in%20a%20long%20dark%20coat%20walking%20through%20snow%2C%20muted%20blue%20and%20grey%20tones%2C%20nostalgic%20cinematic%20mood%2C%20no%20text%2C%20painterly%20illustration&width=600&height=900&seq=tv-poster-13&orientation=portrait',
    tags: ['年代', '剧情', '家庭'],
    region: '中国大陆',
    year: 2025,
    episodes: 34,
    director: '陆迁',
    cast: ['韩霜', '江远洲'],
    synopsis:
      '上世纪九十年代的东北小城，一场大雪掩埋了一段无人提起的往事。韩霜带着女儿回到这里，只为寻找父亲失踪那年的真相。随着老工业区一间间旧厂房被重新打开，一个时代的隐痛与温情缓缓浮现。',
    rating: 9.1,
    popularity: 7310,
    createdAt: '2025-01-20',
    roles: [
      { actor: '韩霜', role: '饰 韩霜', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20resilient%20Chinese%20woman%20in%20a%20dark%20wool%20coat%2C%20cold%20winter%20lighting%2C%20pale%20grey%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-13a&orientation=squarish' },
      { actor: '江远洲', role: '饰 江远洲', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20stoic%20Chinese%20man%20in%20a%20vintage%20coat%20and%20scarf%2C%20muted%20winter%20lighting%2C%20cool%20grey%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-13b&orientation=squarish' },
    ],
  },
  {
    id: 'xingchen',
    title: '星辰之下',
    poster: 'https://readdy.ai/api/search-image?query=romantic%20fantasy%20drama%20poster%2C%20two%20figures%20standing%20on%20a%20hilltop%20under%20a%20glowing%20starry%20night%20sky%20with%20a%20bright%20meteor%2C%20dreamy%20indigo%20and%20soft%20pink%20nebula%20tones%2C%20whimsical%20atmosphere%2C%20no%20text%2C%20painterly%20illustration&width=600&height=900&seq=tv-poster-14&orientation=portrait',
    tags: ['爱情', '奇幻', '青春'],
    region: '中国大陆',
    year: 2025,
    episodes: 26,
    director: '苏也',
    cast: ['沈星回', '白鹿'],
    synopsis:
      '天文社的沈星回有一个秘密：他能在流星划过的瞬间看见未来。直到他遇见了那个将在七年后消失的女孩，他才明白，有些相遇本就是一场注定的流星。为了改变结局，他决定与时间赛跑。',
    rating: 8.8,
    popularity: 8420,
    createdAt: '2025-10-09',
    roles: [
      { actor: '沈星回', role: '饰 沈星回', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20dreamy%20young%20Chinese%20man%20with%20soft%20features%20and%20dark%20hair%2C%20deep%20indigo%20lighting%2C%20starry%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-14a&orientation=squarish' },
      { actor: '白鹿', role: '饰 白鹿', avatar: 'https://readdy.ai/api/search-image?query=portrait%20of%20a%20luminous%20young%20Chinese%20woman%20with%20wavy%20hair%20and%20soft%20smile%2C%20dreamy%20purple%20lighting%2C%20twilight%20background%2C%20editorial%20headshot&width=300&height=300&seq=role-14b&orientation=squarish' },
    ],
  },
];

export const tvRegions: string[] = ['全部地区', '中国大陆', '韩国', '美国'];
export const tvGenres: string[] = ['全部类型', '古装', '现代', '悬疑', '爱情', '都市', '家庭', '年代', '青春', '科幻', '美剧', '韩国'];
export const tvYears: string[] = ['全部年份', '2025', '2024'];
export const tvSortOptions: string[] = ['默认排序', '热度优先', '最新上架', '评分最高'];